/**
 * AI chat store — a single source of truth for the active chat thread.
 *
 * Sprint AI-MODULE v2.3 UX-2/UX-3. Both AiChatBubble (mounted globally
 * in Layout) and the dedicated AiChat page write ``activeThreadId``
 * here so the two surfaces stay in sync: the bubble picks up the
 * user's active thread when they navigate away from the dedicated
 * page, and vice versa. Persisted to localStorage so refresh keeps
 * you where you were.
 */
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AiChatState {
  activeThreadId: string | null;
  setActiveThreadId: (id: string | null) => void;
  clear: () => void;
}

export const useAiChatStore = create<AiChatState>()(
  persist(
    (set) => ({
      activeThreadId: null,
      setActiveThreadId: (activeThreadId) => set({ activeThreadId }),
      clear: () => set({ activeThreadId: null }),
    }),
    {
      name: 'vortex.ai.chat',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ activeThreadId: s.activeThreadId }),
    },
  ),
);
